import React from 'react';

class BasePage extends React.Component {
	componentDidMount() {
		window.scrollTo(0, 0);
	}
}

export default BasePage;



// WEBPACK FOOTER //
// ./src/routes/Site/BasePage.js